<template>
  <div v-if="current">
    
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field
                label="Descrição"
                v-model="current.description"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Status"
                v-model="current.enabled"
                :items="status"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Host"
                v-model="current.host"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Porta"
                v-model="current.port"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Usuário"
                v-model="current.username"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Senha"
                v-model="current.password"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Tech Prefix"
                v-model="current.techPrefix"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Tipo"
                v-model="current.type"
                :items="types"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Discagem"
                v-model="current.dialplan"
                :items="dialplans"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Observação"
                v-model="current.obs"
                outlined
                dense
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    status: [
      { value: true, text: "Habilitado" },
      { value: false, text: "Desabilitado" }
    ],
    types: [
      { value: "sip", text: "SIP" },
      { value: "local", text: "Local" },
      { value: "voip", text: "Voip" },
      { value: "did", text: "DID" }
    ],
    dialplans: [
      { value: 1, text: "E164" },
      { value: 2, text: "00 + E164" },
      { value: 3, text: "0 + ddd + numero e 00 + ddi + numero" },
      { value: 4, text: "Tech Prefix + E164" },
      { value: 5, text: "Tech Prefix + [portabilidade] + E164" }
    ],
    portabilidade: [
      { value: true, text: "Habilitado" },
      { value: false, text: "Desabilitado" }
    ],
    dialog_loading: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/trunk/0", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    save: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/trunk", this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Tronco cadastrado com sucesso!");
          router.push({ path: "/trunk" });
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar formulario de cadastro!");
          console.log(error);
        });
    }
  }
};
</script>